import { useMutation, useQuery } from "@apollo/client";
import { AppContext } from "App";
import { FETCH_QC_PREVIEW, SAVE_SIMPLE_REPORT } from "pages/qc/graphql";
import { useContext } from "react";
import { Switcher } from "components/base/Form";
import Spinner from "components/base/Spinner";
import Errors from "components/base/Errors";
import { Alert } from "components/base/Toast";
import { INTERNAL } from "utils/permissions";

const PreviewQCReport = ({ id }) => {
  const { hasPermission } = useContext(AppContext);
  const { loading, error, data } = useQuery(FETCH_QC_PREVIEW, {
    variables: { id },
  });
  const [saveReport, saveReportRes] = useMutation(SAVE_SIMPLE_REPORT, {
    onCompleted(res) {
      Alert(
        "success",
        res.saveSimpleQcReport.qcReport.sharedWithCustomerAt
          ? "Shared with Customer."
          : "Disabled shared with customer.",
      );
    },
    onError(error) {
      Alert("error", error.message);
    },
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const canShareWithCustomer = hasPermission(INTERNAL);

  return (
    <div className="flex-1 flex flex-col">
      {canShareWithCustomer ? (
        <div className="px-6 py-6 md:px-10 flex items-center space-x-3">
          <label>Share with Customer</label>
          <Switcher
            isOn={data.report.sharedWithCustomerAt !== null}
            disabled={saveReportRes.loading}
            loading={saveReportRes.loading}
            onChange={() =>
              saveReport({
                variables: {
                  id,
                  shareWithCustomer: data.report.sharedWithCustomerAt === null,
                },
              })
            }
          />
        </div>
      ) : null}
      <iframe
        title="QC Report"
        className="flex-1 w-full bg-white rounded shadow-sm"
        srcDoc={data.report.html}
      />
    </div>
  );
};

export default PreviewQCReport;
